import { useCallback, useState } from 'react';
import {
  checkInventoryAvailability,
  type AvailabilityCheckParams,
  type AvailabilityCheckResult,
} from '@/modules/reservations/services';
import { formatReservationApiError } from '@/services/api/reservations.api';

export function useReservationAvailability() {
  const [checking, setChecking] = useState(false);
  const [result, setResult] = useState<AvailabilityCheckResult | null>(null);
  const [error, setError] = useState<string | null>(null);

  const check = useCallback(async (params: AvailabilityCheckParams) => {
    setChecking(true);
    setError(null);
    try {
      const availability = await checkInventoryAvailability(params);
      setResult(availability);
      return availability;
    } catch (err) {
      setError(formatReservationApiError(err));
      setResult(null);
      return null;
    } finally {
      setChecking(false);
    }
  }, []);

  const reset = useCallback(() => {
    setResult(null);
    setError(null);
  }, []);

  return { checking, result, error, check, reset };
}
